import React, { useState } from 'react';
import { newsAPI } from '../utils/api/newsAPI';
import otherNewsAPI from '../utils/api/otherNewsAPI';
import homeNewsAPI from '../utils/api/homeNewsAPI';
import { buildAbsoluteShareUrl } from '../utils/contentEngagement';
import './CompactShareButton.css';

async function incrementShareCount(contentType, contentId) {
  if (!contentId) {
    return;
  }

  if (contentType === 'other-news') {
    await otherNewsAPI.incrementShare(contentId);
    return;
  }

  if (contentType === 'home-news') {
    await homeNewsAPI.incrementShare(contentId);
    return;
  }

  await newsAPI.incrementNewsShare(contentId);
}

function CompactShareButton({
  title,
  url,
  description,
  contentId,
  contentType = 'news',
  className = '',
  label = 'शेयर'
}) {
  const [copied, setCopied] = useState(false);

  const handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const shareUrl = buildAbsoluteShareUrl(url);
    const shareText = description ? `${title} - ${description}` : title;

    try {
      await incrementShareCount(contentType, contentId);
    } catch (error) {
      console.error('Failed to record share event:', error);
    }

    try {
      if (navigator.share) {
        await navigator.share({
          title,
          text: shareText,
          url: shareUrl
        });
        return;
      }

      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch (error) {
      console.error('Share failed:', error);
    }
  };

  return (
    <button
      type="button"
      className={`compact-share-btn ${className}`.trim()}
      onClick={handleClick}
      title="इस खबर को शेयर करें"
      aria-label="इस खबर को शेयर करें"
    >
      {copied ? 'लिंक कॉपी' : `🔗 ${label}`}
    </button>
  );
}

export default CompactShareButton;